module.exports = __webpack_public_path__ + "static/media/cards-team.beb888b0.svg";